<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/p23-1.jpg"
              width="100%"
              alt="Blueshark R1 waterprool"
            />
          </div>
          <div class="text fs_middle fw_bold t23">
            IPX5 Waterproof Panel Display
            <div class="fs_tiny color_gray t23_1">IPX5 등급의 방수/방진</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/sk/p23-2.jpg"
              width="100%"
              alt="Blueshark R1 water level sensor"
            />
          </div>
          <div class="text fs_middle fw_bold t23">
            Water Level Sensor
            <div class="fs_tiny color_gray t23_1">수위 자동 감지 센서</div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t23 {
  top: 4vw;
  text-align: center;
  width: 100%;
}
.t23_1 {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper_sk/swiper23.vue